// import { login, logout, getInfo } from '@/api/user'
import { setToken, getToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    menus: [],
    info: {},
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        // login(username, userInfo.password).then(response => {
        //   const data = response.data.data.access_token
        //   setToken(data)
        //   commit('SET_TOKEN', data)
        //   if (response.data.code === 1) {
        //     resolve(response.data)
        //   } else {
        //     reject(response.data)
        //   }
        // }).catch(err => {
        //   reject(err)
        // })
        const data = username + '123'
        setToken(data)
        commit('SET_TOKEN', data)
        resolve(data)
      })
    },

    // 获取用户信息
    GetInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        // getInfo().then(response => {
        //   const data = response.data.data
        //   commit('SET_MENUS', data.systemProject)
        //   commit('SET_INFO', data.systemUser)
        //   resolve(response)
        // }).catch(error => {
        //   reject(error)
        // })
        const data = {
          name: '小关',
          age: '35'
        }
        commit('SET_INFO', data)
        resolve(data)
      })
    },
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        // getInfo().then(response => {
        //   const data = response.data.data
        //   commit('SET_MENUS', data.systemMenus)
        //   commit('SET_INFO', data.systemUser)
        //   resolve(response)
        // }).catch(error => {
        //   reject(error)
        // })
        const data = {
          name: '123',
          age: '35'
        }
        commit('SET_INFO', data)
        resolve(data)
      })
    },

    // 登出
    async LogOut ({ commit, state, dispatch }) {
      try {
        // await logout()
        await dispatch('FedLogOut')
      } catch (error) {
        return error
      }
    },

    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
  },
}

export default user
